import React from "react";

function SelectDataToDisplay() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 464 464">
      <path
        fill="#d1e7f8"
        d="M0 64h464v320H0zm0 0"
        data-original="#d1e7f8"
      ></path>
      <path
        fill="#005ece"
        d="M256 416v48h160v-48zm0 0"
        data-original="#005ece"
      ></path>
      <path
        fill="#006df0"
        d="M0 0h464v64H0zm0 0"
        data-original="#006df0"
      ></path>
      <path
        fill="#00e02a"
        d="M48 112v80h80v-80zm0 128v80h80v-80zm0 0"
        data-original="#d80027"
      ></path>
      <path
        fill="#bcd0df"
        d="M208 384h256V160c0 92.855-145.457 224-256 224zm0 0"
        data-original="#bcd0df"
      ></path>
      <path
        fill="#ffdaaa"
        d="M272 416h127.832l.106-14.398a31.984 31.984 0 015.367-17.532l5.32-8A32.025 32.025 0 00416 358.313v-64.864c.004-16.648-12.754-30.515-29.344-31.898L320 256v-72c0-8.836-7.164-16-16-16s-16 7.164-16 16v110.465a8 8 0 01-14.93 4L256 268.887a15.999 15.999 0 00-13.95-8.504 16 16 0 00-13.737 24.504L256 360.559l8.61 16.304a66.73 66.73 0 013.199 7.137A63.966 63.966 0 01272 406.734zm0 0"
        data-original="#ffdaaa"
      ></path>
      <path
        fill="#f1f2f2"
        d="M24 24h16v16H24zm32 0h16v16H56zm32 0h16v16H88zm0 0"
        data-original="#f1f2f2"
      ></path>
      <path
        fill="#2488ff"
        d="M232 104h32v16h-32zm48 0h144v16H280zm-48 32h192v16H232zm0 40h32v16h-32zm112 0h80v16h-80zm0 32h80v16h-80zm-112 0h32v16h-32zm0 0"
        data-original="#2488ff"
      ></path>
      <path
        fill="#2b3990"
        d="M87.29 178.695l-28.993-28.648 11.238-11.383 18.528 18.313 59.058-50.57 10.399 12.16zm0 128l-28.993-28.648 11.238-11.383 18.528 18.313 59.058-50.57 10.399 12.16zm0 0"
        data-original="#2b3990"
      ></path>
    </svg>
  );
}

export default SelectDataToDisplay;
